<template>
  <b-modal
    centered
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container>
      <b-row>
        <b-col>
          <h5 class="text-info">{{ $t("globals.change_agent") }}:</h5>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-form-select
            style="max-width: 250px"
            v-model="new_agent_id"
            :options="agentOptions"
          />
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn size="sm" variant="success" @click="save">
            {{ $t("globals.save") }}
          </b-btn>
        </b-col>
        <b-col>
          <b-btn class="float-right" size="sm" @click="close" variant="warning">
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    show: Boolean,
    close: Function
  },
  data() {
    return {
      new_agent_id: 0,
      agentOptions: []
    };
  },
  methods: {
    ...mapActions("axios_mod", {
      simpleMutation: "simpleMutation",
      fetchAgentsFromStore: "fetchAgents"
    }),
    loadAgents() {
      this.fetchAgentsFromStore({ this_ref: this }).then(res => {
        if (res) {
          this.agentOptions = res;
        }
      });
    },
    save() {
      let data = {
        query: `
          mutation { 
            res: InquiryUpdateAgent (
              inquiry_id: ${parseInt(this.$route.params.id)},
              new_agent_id: ${parseInt(this.new_agent_id)}
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.new_agent_id = 0;
        this.close();
      });
    }
  },
  mounted() {
    this.loadAgents();
  }
};
</script>
